/**
 * Payment links: the cashier makes one for the sale (QR, SMS or email) and the customer pays on
 * the store's own page at /p/<code>, by Mobile Money or card. The till watches the link and
 * completes the sale once its Paystack payment succeeds.
 */
import { api } from "./api";
import type { Intent, IntentStatus, Provider } from "./paystack";

export type TillLink = {
  id: string;
  code: string;
  url: string;
  saleId: string;
  amount: number;
  method: "momo" | "card" | "any";
  status: "open" | "paid" | "cancelled" | "expired";
  smsTo: string | null;
  emailTo: string | null;
  sentAt: number | null;
  openedAt: number | null;
  expiresAt: number;
  intent: Intent | null;
};

export type PublicLink = {
  code: string;
  store: { name: string; logo: string | null };
  amount: number;
  lines: { name: string; qty: number; total: number }[];
  customer: string | null;
  method: "momo" | "card" | "any";
  status: "open" | "paid" | "cancelled" | "expired";
  expiresAt: number;
  attempt: { method: string; channel: string; status: IntentStatus; message: string | null; phone: string | null; provider: string | null; paidWith: string | null; accessCode: string | null } | null;
};


// ── Customer's page ──
const pub = (code: string, p = "") => `/api/v1/pay/${encodeURIComponent(code)}${p}`;
export const loadPublic = (code: string) => api<{ link: PublicLink }>(pub(code)).then((r) => r.link);
export const payMomo = (code: string, phone: string, provider: Provider) => api<{ link: PublicLink }>(pub(code, "/momo"), { body: { phone, provider } }).then((r) => r.link);
export const payCard = (code: string) => api<{ link: PublicLink }>(pub(code, "/card"), { body: {} }).then((r) => r.link);
export const payOtp = (code: string, otp: string) => api<{ link: PublicLink }>(pub(code, "/otp"), { body: { otp } }).then((r) => r.link);
